export const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
}

export const locations = [
  {
    city: 'Los Angeles, CA',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158765/frontend_assets/locationImages/Los_Angeles.jpg',
    name: 'los-angeles',
    listName: 'ca/los angeles'
  },
  {
    city: 'Las Vegas, NV',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158726/frontend_assets/locationImages/Las_Vegas.jpg',
    name: 'las-vegas',
    listName: 'nv/las vegas'
  },
  {
    city: 'Miami, FL',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158987/frontend_assets/locationImages/Miami.jpg',
    name: 'miami',
    listName: 'fl/miami'
  },
  {
    city: 'Austin, TX',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721159005/frontend_assets/locationImages/Austin.jpg',
    name: 'austin',
    listName: 'tx/austin'
  },
  {
    city: 'San Francisco, CA',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158741/frontend_assets/locationImages/San_Francisco.jpg',
    name: 'san francisco',
    listName: 'ca/san francisco'
  },
  {
    city: 'San Diego, CA',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158757/frontend_assets/locationImages/San_Diego.jpg',
    name: 'san diego',
    listName: 'ca/san diego'
  },
  {
    city: 'Phoenix, AZ',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158760/frontend_assets/locationImages/Phoenix.jpg',
    name: 'phoenix',
    listName: 'az/phoenix'
  },
  {
    city: 'Chicago, IL',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158774/frontend_assets/locationImages/Chicago.jpg',
    name: 'chicago',
    listName: 'il/chicago'
  },
  {
    city: 'Daytona Beach, FL',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158726/frontend_assets/locationImages/Daytona_Beach.jpg',
    name: 'daytona beach',
    listName: 'fl/daytona beach'
  },
  {
    city: 'Tampa, FL',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158762/frontend_assets/locationImages/Tampa.jpg',
    name: 'tampa',
    listName: 'fl/tampa'
  },
  {
    city: 'Honolulu, HI',
    image:
      'https://res.cloudinary.com/twisted-road/image/upload/g_center,q_auto,f_auto,w_230,h_280/v1721158984/frontend_assets/locationImages/Honolulu.jpg',
    name: 'honolulu',
    listName: 'hi/honolulu'
  },
]

export const getHref = (title, brandName) => {
  let url = ''
  if (title === 'electric' || title === 'trike') {
    url =
      '/search?category=other' +
      '&makes=' +
      brandName +
      '&max_distance=10000&min_distance=0'
  } else if (
    title === 'modern classics' ||
    title === 'heritage classics' ||
    title === 'scramblers'
  ) {
    url =
      '/search?category=standard' +
      '&makes=' +
      brandName +
      '&max_distance=10000&min_distance=0'
  } else if (title === 'sportbikes') {
    url =
      '/search?category=sport' +
      '&makes=' +
      brandName +
      '&max_distance=10000&min_distance=0'
  } else {
    url =
      '/search?category=' +
      title +
      '&makes=' +
      brandName +
      '&max_distance=10000&min_distance=0'
  }
  return url
}

export const harleyDescription =
  'Twisted Road offers all brands of motorcycles for rent all over the country, and we have plenty of Harley-Davidson motorcycles for you to choose from. Whether you just want a small bike to rent, like the entry-level Sportster, or something more adventurous, like the Pan America, our selection runs broad so you can choose a bike for your liking.'

export const harleyDescription2 =
  'Many of our Harley-Davidson motorcycles for rent include passenger pegs and sissy bars, farings, tour packs, and storage fo a longer journey. Many people ask themselves “where can I rent a Harley?” and fortunately, Twisted Road has Harleys for rent in Los Angeles, Miami, Las Vegas, Chicago, and many other cities across the country.'

export const harleyOverview =
  'A lot has happened since 1903 when William Harley, and his friends Walter, Arthur, and William Davidson finished their first motorcycle in the famed Harley-Davidson shed in Milwaukee, Wisconsin. The company has grown into the leading motorcycle manufacturer, and specializes in touring and cruiser motorcycles.'

export const harleyOverview2 = undefined

export const harleyImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/harleyImages/harleyHero.jpeg',
  logo:
    'https://res.cloudinary.com/twisted-road/image/upload/c_scale,q_100/v1572480187/frontend_assets/harleyImages/harleyLogo.png',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/harleyImages/mainHarleyImage.png',
}

export const harleyHowToRent = {
  'Browse Models:': 'Explore our selection of Harley-Davidson motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Harley-Davidson model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Harley-Davidson motorcycle and hit the road or trail!'
}

export const harleyReadyToRide = {
  description: 'Experience the thrill and performance of a Harley-Davidson motorcycle with Twisted Road. Whether you’re planning an off-road adventure or a city tour, our selection of Harley-Davidson bikes ensures you’ll find the perfect ride. Book your Harley-Davidson motorcycle rental today and start your journey!',
}

export const harleyBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/harleyImages/Cruiser.jpg',
        altText:
          'Harley-Davidson cruiser motorcycle parked outside against a brick wall city backdrop | Twisted Road Motorcycle Rental',
        title: 'Cruiser',
        parahraphOne:
          'When we think of Harley, we think of cruisers. These bikes combine authentic American styling with modern technology for the most versatile riding experiences. HD’s cruiser category includes smaller entry-level bikes.',
        parahraphTwo:
          'Cruisers are typically used for day trips and shorter overnight rides, as they don’t offer big fairings for wind protection and rarely have ample storage for anything more than a weekend getaway.',
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/harleyImages/Touring.jpg',
        altText:
          'Harley-Davidson touring motorcycle parked outside against rocky backdrop | Twisted Road Motorcycle Rental',
        title: 'Touring',
        parahraphOne:
          'Want a bike for the open road? You need to rent a Harley touring motorcycle, as these beasts are built for the long ride. Harley knew you’d be riding on the highway for days - or weeks - on end, so they built the machines to do the job. Touring bikes often have massive fairings for wind protection, ample storage for long trips, and added navigation and audio options.',
        parahraphTwo: '',
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/harleyImages/Adventure.jpg',
        altText:
          'Harley-Davidson adventure motorcycle parked outside against mountain backdrop | Twisted Road Motorcycle Rental',
        title: 'Adventure',
        parahraphOne:
          'Harley-Davidson recently entered the adventure bike category with the launch of their Pan America motorcycle. With an upright seating position and increased ground clearance, adventure motorcycles are engineered to be able to ride on the street or offroad with ease. Although Twisted Road motorcycles must be ridden on the street, you can always rent the Harley-Davidson Pan America on Twisted Road.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/harleyImages/Trike.jpg',
        altText:
          'Harley-Davidson trike motorcycle parked outside against brick building | Twisted Road Motorcycle Rental',
        title: 'Trike',
        parahraphOne:
          'These three-wheeled motorcycles are the perfect option for riders who can no longer safely operate a two-wheeled bike. Harley invented this category, and their trikes are stylish with attitude just like the rest of their lineup.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/harleyImages/Electric.jpg',
        altText:
          'Harley-Davidson LiveWire motorcycle parked outside against geometric building backdrop | Twisted Road Motorcycle Rental',
        title: 'Electric',
        parahraphOne:
          'Harley-Davidson introduced their first electric motorcycle, the LiveWire, in 2019. These quiet rides allow the rider to experience exceptional acceleration while protecting the environment. There are plenty of LiveWires for rent on Twisted Road. Just like when riding any motorcycle, please make sure to read up on rider safety, and also how to travel with gear so you are all ready to rent on Twisted Road.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
]

export const triumphDescription =
  'For people who are looking for a Triumph motorcycle for rent, Twisted Road has plenty. From the Bonneville to the Thruxton, and the Rocket 3 to the Tiger, this motorcycle company has a broader range of models than any other manufacturer. Many people ask themselves “where can I rent a Triumph?” and fortunately, Twisted Road has Triumphs for rent in Los Angeles, Miami, Las Vegas, Chicago, and many other cities across the country.'

export const triumphDescription2 = ''

export const triumphOverview =
  'When people think of classic motorcycle styles, they often imagine Steve McQueen riding his Triumph Bonneville in the Great Escape. However, this iconic motorcycle company has been manufacturing motorcycles since 1898, decades before this movie was released. Also, triumph is the only motorcycle company that has mastered every style of motorcycle. From Modern Classics and Adventure bikes to Cruisers and Supersports. Their versatility and performance is impressive.'

export const triumphOverview2 = undefined

export const triumphImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/triumphImages/backgroundNew.jpg',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/triumphImages/triumphBike.png',
}

export const triumphHowToRent = {
  'Browse Models:': 'Explore our selection of Triumph motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Triumph model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Triumph motorcycle and hit the road or trail!'
}

export const triumphReadyToRide = {
  description: 'Experience the thrill and performance of a Triumph motorcycle with Twisted Road. Whether you’re planning an off-road adventure or a city tour, our selection of Triumph bikes ensures you’ll find the perfect ride. Book your Triumph motorcycle rental today and start your journey!',
}

export const triumphBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/triumphImages/image2.jpg',
        altText:
          'Triumph Bonneville motorcycle parked outside with a windy road | Twisted Road Motorcycle Rental',
        title: 'Modern Classics',
        parahraphOne:
          'The modern classics are almost all variations of the classic Bonneville styling. For example, the Triumph Scrambler, is a Bonneville with a modified exhaust, slightly larger wheels (to provide greater clearance), and some other cosmetic alterations. The Modern Classics include the Bonneville, Scrambler, Street Twin, Thruxton, Bobber, Speedmaster, and Speed Twin.',
        parahraphTwo:
          'These bikes are well designed for urban riding and short jaunts. They aren’t really built for longer rides, although many riders have rented Triumph Bonnevilles to take weeklong vacations.',
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/triumphImages/image6.jpg',
        altText:
          'Triumph Tiger adventure motorcycle on a windy road with autum trees and mountaints | Twisted Road Motorcycle Rental',
        title: 'Adventure',
        parahraphOne:
          'When people want a Triumph adventure motorcycle for rent, they are always thinking of the Triumph Tiger. Adventure bikes are designed with high clearance, and upright riding position, and hard cases for storage. People enjoy riding these bikes both on-road and offroad, through streams and on dirt trails. They aren’t nimble, but they are manufactured to handle all sorts of terrain.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/triumphImages/image5.jpg',
        altText:
          'Triumph Rocket 3 motorcycle next to the ocean | Twisted Road Motorcycle Rental',
        title: 'Cruiser',
        parahraphOne:
          'Although Triumph doesn’t have a stable of cruisers, it offers The Rocket 3 which is in a class by itself. The bike has a similar riding position to most cruisers, but isn’t really designed for longer rides. As one of the most powerful production motorcycles in existence, this bike offers tons of torque and aggression. In addition to the Rocket, Triumph used to manufacture the Triumph America, which can also be found for rent on Twisted Road. This motorcycle offers more of a cruiser feel, and is perfect for longer rides.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/triumphImages/image4.jpg',
        altText:
          'Triumph Street Triple sportbike motorcycle to rent in a parking garage | Twisted Road Motorcycle Rental',
        title: 'Sportbikes',
        parahraphOne:
          'Sportbikes are built for speed. With lightweight designs and high power, these bikes allow riders to experience the thrill of the ride. Triumph’s sportbikes include the Trident, the Street Triple, and the Speed Triple.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
]

export const bmwDescription =
  'BMW motorcycles bring a lot of history and variety to life on two wheels, and if you’re looking for a BMW motorcycle to rent, Twisted Road has an extensive selection. When non-riders think of BMW motorcycles, they tend to think of classic styling, like the R75/5 toaster tank, or maybe the R71 with a sidecar used in Germany during WWII. But as riders know, BMW is a leader in adventure bikes with their 1200 GSA, their touring motorcycle, the K1600, a line of high-performance sportbikes, the S1000 RR, and most recently a versatile standard/classic motorcycle, the R Nine T. It’s this riding and engineering versatility that makes BMW such an impressive brand.'

export const bmwDescription2 =
  'Many people ask themselves “where can I rent a BMW motorcycle?” and fortunately, Twisted Road has BMWs for rent in Los Angeles, Miami, Las Vegas, Chicago, and many other cities across the country.'

export const bmwOverview =
  'BMW started manufacturing motorcycle motorcycles in 1921 for other companies, and the BMW Motorrad brand officially began in 1923. In this year, they launched the boxer twin engine, which is still being used in motorcycles today. The company has evolved into an engineering powerhouse with a breadth of motorcycles that is rarely matched by other companies. Their focus on engineering and performance - coupled with beautiful design and functionality - make BMW motorcycles one of the most desirable brands on the planet. Fortunately, Twisted Road has more than 250 BMW motorcycles for rent all across the United States.'

export const bmwOverview2 = undefined

export const bmwImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/bmwImages/bmwBackground.jpg',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/bmwImages/bmwBike.png',
}

export const bmwHowToRent = {
  'Browse Models:': 'Explore our selection of BMW motorcycles available for rent.',
  'Choose Your Ride:': 'Select the BMW model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your BMW motorcycle and hit the road or trail!'
}

export const bmwReadyToRide = {
  description: 'Experience the thrill and performance of a BMW motorcycle with Twisted Road. Whether you’re planning an off-road adventure or a city tour, our selection of BMW bikes ensures you’ll find the perfect ride. Book your BMW motorcycle rental today and start your journey!',
}

export const bmwBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/bmwImages/image1.jpg',
        altText:
          'Black BMW R18 cruiser motorcycle in front of concrete wall backdrop | Twisted Road Motorcycle Rental',
        title: 'Heritage Classics',
        parahraphOne:
          'The Heritage Classics are motorcycles that have extremely versatile performance and classic styling. These bikes are perfect for short urban weekend rides, or longer Sunday cruises.',
        parahraphTwo:
          'There are two base motorcycle models in this category: the R18 and the R Nine T. The R18 is BMW’s cruiser. It comes naked, without any storage or a faring, or fully dressed with a tour pack and other luxuries. The R Nine T is a standard motorbike with an exceptional amount of customization options. For example, there’s the R Nine T Scrambler (which was ridden by Tom Cruise in Mission Impossible 6), which has higher exhaust pipes and greater clearance for those who want to enjoy some off-road riding. Also, there’s the R Nine T Urban GS, which is perfect for city rides and shorter jaunts.',
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/bmwImages/image11.jpg',
        altText:
          'BMW 1200 GSA adventure motorcycle near ocean on rocks | Twisted Road Motorcycle Rental',
        title: 'Adventure',
        parahraphOne:
          'The BMW Motorrad name has become synonymous with their all-terrain, battleproof adventure motorcycles. In fact, Charlie Boorman and Ewan McGregor rode BMW 1150 GS adventure bikes when they rode from London to New York in The Long Way Round. These bikes often feature hard aluminum panniers, extremely high clearance, high fairings, and all sorts of other motorcycle accessories to protect this beast when riding through snow, gravel, mud, and streams.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/bmwImages/image7.jpg',
        altText:
          'Red BMW sportbike motorcycle outside on asphalt | Twisted Road Motorcycle Rental',
        title: 'Sport',
        parahraphOne:
          'When we see a BMW motorcycle with the letter R at the end of the name (like the S 1000 R) or a double R, (like the S 1000 RR), we are truly in for high performance. These letters all have meaning. The R is for Road, and the RR is for Road Race. The BMW engineers built these bikes for speed.',
        parahraphTwo:
          'If you can’t handle the 190 mph top speed of the M 1000 RR, or accelerating from 0-80mph in under four seconds like the S 1000 RR, these motorcycles aren’t for you. However, if you enjoy seeing how the BMW engineers push the limits on two-wheeled performance, these supersport motorcycles are perfect.',
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/bmwImages/image3.jpg',
        altText:
          'BMW touring motorcycle in front of concrete wall | Twisted Road Motorcycle Rental',
        title: 'Touring',
        parahraphOne:
          'The BMW touring motorcycles offer a smooth ride and a sense of luxury around every turn. From the K1600GT, and the K 1600 Grand America, to the R 1250 RT, you’re sure to find a motorcycle that meets your needs as you explore the open road.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
]

export const ducatiDescription =
  'For those people who are interested in renting a Ducati, Twisted Road has hundreds available across the United States. This Italian company has led the industry in high-performance motorcycles for over 70 years. From the ubiquitous Monster to the eye-catching Panigale, and the Hypermotard to the Multistrada, Ducati has really made their mark with their breadth of vehicles.'

export const ducatiDescription2 =
  'Many people ask themselves “where can I rent a Ducati?” and fortunately, Twisted Road has Ducatis for rent in Los Angeles, Miami, Las Vegas, Chicago, and many other cities across the country.'

export const ducatiOverview =
  'Some brands are known by a simple color. UPS Brown. Tiffany Blue. The Home Depot Orange. And of course, Ducati Red. Beneath that red color is speed, passion, heat, excitement, and beauty. As we know, Ducati embodies all of this. With Italian styling and performance, Ducatis are built to perform. From the turn of the key to the feeling of the roar between your legs as the earth moves under the rubber tires, the Ducati feeling is fueled with emotion.'

export const ducatiOverview2 = undefined

export const ducatiImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/ducatiImages/ducatiBackground.jpg',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/ducatiImages/ducatiBike.png',
}

export const ducatiHowToRent = {
  'Browse Models:': 'Explore our selection of Ducati motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Ducati model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Ducati motorcycle and hit the road or trail!'
}

export const ducatiReadyToRide = {
  description: 'Experience the thrill and performance of a Ducati motorcycle with Twisted Road. Whether you’re planning an off-road adventure or a city tour, our selection of Ducati bikes ensures you’ll find the perfect ride. Book your Ducati motorcycle rental today and start your journey!',
}

export const ducatiBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/ducatiImages/image1.jpg',
        altText:
          'Red Ducati Panigale sportbike motorcycle outside on asphalt | Twisted Road Motorcycle Rental',
        title: 'Sportbikes',
        parahraphOne:
          'Ducati sportbikes are thought of as racing machines. Some models, such as the Monster, is a naked sportbike, whereas others, like the Panigale or the Superleggera, include fairings to reduce drag and increase performance. The Hypermotard and the Streetfighter are two other models that can be seen gingerly navigating tight turns and the open road.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/ducatiImages/image3.jpg',
        altText:
          'Ducati Multistrada adventure motorcycle and rider outdoors on a hilltop | Twisted Road Motorycle Rental',
        title: 'Adventure',
        parahraphOne:
          'Although Ducati’s adventure bikes don’t have as strong a reputation as KTM or BMW’s adventure bikes, that shouldn’t deter you. Their Multistrada comes with up to 170hp to help you navigate all types of terrain. It’s a big bike, so if you’re looking for something a little smaller and more manageable, renting a Ducati Hyperstrada is a perfect alternative. Most recently, our friends at Ducati released the DesertX, which was built with high-heat and fine sand in mind. Another first for this moto powerhouse.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/ducatiImages/image2.jpg',
        altText:
          'Yellow Ducati scrambler motorcycle on the dirt in a forest | Twisted Road Motorcycle Rental',
        title: 'Scramblers',
        parahraphOne:
          'Ducati reintroduced its Scrambler in 2015 which kicked off an evolution of style that only Ducati can master. Scramblers are made for off-road versatility. With their elevated clearance, high fenders, headlight guards, and high exhausts, they allow riders to hit the dirt and mud without thinking of the consequences. But these are also street bikes, and they do really well in urban environments. In fact, they do so well that Ducati continued to innovate with newer models, like the Desert Sled, the Urban Motard, and the Icon. These are just a few models in the Ducati Scrambler line, but we don’t expect their innovation to end anytime soon.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
]

export const indianDescription =
  'When you’re looking for an Indian motorcycle for rent, Twisted Road has the broadest selection available. Whether you just want the classic styling of an Indian Chief Vintage, the nimbleness of the FTR R Carbon, or the swagger of the Indian Scout Bobber, our selection has every option for you to choose.'

export const indianDescription2 =
  'Some of our Indian motorcycles for rent include sissy bars, passenger pegs, and storage for a long trip, while others have a naked look for a quick dayride. Many riders want to know “where can I rent an Indian near me?” and fortunately, Twisted Road has Indians for rent in Las Vegas, Chicago, Miami, Los Angeles, Maui, and many other cities across the country.'

export const indianOverview =
  'Indian Motorcycles’ history is as interesting as their motorcycles are beautiful. The original company - Hendee Manufacturing - was a bicycle company that launched its first moto in 1901. Then, in 1923, the company changed their name to Indian Motocycle Manufacturing Company (note the spelling of the word Motocycle, without the “r”). The company grew as an iconic racing brand and continued to design and manufacture some of the most beautiful motorcycles in the world. Twisted Road has hundreds of Indian motorcycles for rent all across the United States.'

export const indianOverview2 = undefined

export const indianImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/indianImages/indianBackground.webp',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/indianImages/indianBike.png',
}

export const indianHowToRent = {
  'Browse Models:': 'Explore our selection of Indian motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Indian model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Indian motorcycle and hit the road or trail!'
}

export const indianReadyToRide = {
  description: 'Experience the thrill and performance of a Indian motorcycle with Twisted Road. Whether you’re planning an off-road adventure or a city tour, our selection of Indian bikes ensures you’ll find the perfect ride. Book your Indian motorcycle rental today and start your journey!',
}

export const indianBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/indianImages/image3.jpg',
        altText:
          'Grey Indian FTR R Carbon motorcycle outside on asphalt | Twisted Road Motorcycle Rental',
        title: 'Standard',
        parahraphOne:
          'The FTR (or Flat Track Racer) motorcycle is the nimble bike in a family of larger motos. They feature a comfortable upright riding style that enables the rider to be agile through city streets or when riding the backroads. There are five different FTR models (including the FTR S, the Carbon, the Rally, and the Championship Edition) and they each come with the Indian’s powerful reputation for performance.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/indianImages/image2.jpg',
        altText:
          'Red Indian Cruiser motorcycle in a garage | Twisted Road Motorycle Rental',
        title: 'Cruiser',
        parahraphOne:
          'The cruiser category is filled with Indian Scouts and Indian Chiefs, with throaty rumbles that turn heads. The Scout has a handful of different configurations, including the Scout Bobber, the Scout Sixty, and the Scout Rogue. With a relaxed seating position and forward controls, the rider has complete control.',
        parahraphTwo:
          'The Indian Chief is like the Scout’s middle-aged father. A little bigger, a little heavier, and a little slower, but is incredible for longer highway rides. There are a few different Chief configurations, including the Chief Dark Horse, The Chief Bobber, and the Super Chief Limited.',
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/indianImages/image1.jpg',
        altText:
          'Beige Indian Springfield motorcycle on a highway | Twisted Road Motorcycle Rental',
        title: 'Touring',
        parahraphOne:
          'Rounding out the Indian line are their touring motorcycles, which are made for long rides and open highways. Sporting the most comfortable riding positions for the long-haul, these bikes also have significant storage, big fairings, and multiple accessories. These models include the Springfield, The Chieftan, the Challenger, the Roadmaster, and the Pursuit. Some of these tourers are more limited whereas others have complete tour-packs and passenger luxury.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
]

export const hondaDescription =
  'Honda is one of the most versatile motorcycle brands in existence, and when you’re choosing a Honda motorcycle to rent, Twisted Road has plenty of options. From starter bikes like the Monkey and the Grom, to more powerful classics such as the Rebel, they have the cruiser line covered. But with Honda Motorcycles, it doesn’t end with cruisers. The Africa Twin is a leader in adventure bikes, and the Gold Wing sets the global standard with their luxury touring classic.'

export const hondaDescription2 =
  'Many people ask themselves “where can I rent a Honda motorcycle near me?” and fortunately, Twisted Road has Hondas for rent in Chicago, Miami, Los Angeles, Maui, Las Vegas, and many other cities across the country.'

export const hondaOverview =
  'Honda was started by Soichiro Honda in the 1920s, as an auto repair shop, and soon began manufacturing piston rings. When Japan needed affordable transportation options after WWII, Soichiro sold his piston-ring business and began to focus on motorcycles. In 1949, Honda launched their first two-stroke motorcycle, the Model D, and in 1951, they followed with the Dream E with a four-stroke engine. In 1968, Honda celebrated their production of their 10 millionth motorcycle, and has continued to produce millions of well-engineered motorcycles ever since. Honda’s reputation for quality - coupled with such versatile and enduring bikes - make Honda motorcycles such a strong innovator. Twisted Road has hundreds of Honda motorcycles for rent all across the United States.'

export const hondaOverview2 = undefined

export const hondaImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/hondaImages/hondaBackground.webp',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/hondaImages/hondaBike.webp',
}

export const hondaHowToRent = {
  'Browse Models:': 'Explore our selection of Honda motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Honda model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Honda motorcycle and hit the road or trail!'
}

export const hondaReadyToRide = {
  description: 'Experience the thrill and performance of a Honda motorcycle with Twisted Road. Whether you’re planning an off-road adventure or a city tour, our selection of Honda bikes ensures you’ll find the perfect ride. Book your Honda motorcycle rental today and start your journey!',
}

export const hondaBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/hondaImages/image3.jpg',
        altText:
          'Grey Honda Shadow motorcycle outside on asphalt | Twisted Road Motorcycle Rental',
        title: 'Cruiser',
        parahraphOne:
          'Honda’s Cruisers have a reputation for strong performance and excellent reliability. The Honda Rebel (*from 300cc - 1100cc) is just enough of a motorcycle to give people the joy of riding. There are two other models in this collection, the Shadow and the Fury.',
        parahraphTwo:
          'The Shadow has vintage styling and lines, and the Fury which is a sleek looking chopper.',
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/hondaImages/image1.jpg',
        altText:
          'Black Honda Cruiser motorcycle by the beach | Twisted Road Motorycle Rental',
        title: 'Standard',
        parahraphOne:
          'The standard lineup is impressive. At the entry level, there is the Monkey and the Grom, both reasonably fun minibikes to get a little experience. In addition, the CB series of Hondas - CB300, CB500, CB650, and CB1000 - are all standard motorcycles with an engine that might outlive you. These motos are all extremely capable of scratching your motorcycle riding itch.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/hondaImages/image5.jpg',
        altText:
          'White Honda African Twin motorcycle by the mountains | Twisted Road Motorcycle Rental',
        title: 'Adventure',
        parahraphOne:
          'Honda first launched their Africa Twin motorcycle in 1988, and continued producing it until 2003, when they took a short break. When this motorcycle was reintroduced in 2016, it was a welcome addition to the Honda line. The beautiful appearance of this motorcycle and its offroad - and on-road - functionality, make it a desirable ride. Although the Africa Twin is Honda’s premiere adventure bike, the NC750X is also a strong adventure moto.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/hondaImages/image6.jpg',
        altText:
          'White Honda CBR1000RR motorcycle on a track | Twisted Road Motorcycle Rental',
        title: 'Sportbikes',
        parahraphOne:
          'Honda has been producing sportbikes for decades, and with every model comes improved performance and handling. The high-performance models are the CBR600RR, the CBR1000RR, and the CBR1000RR-R Fireblade. Each of these were made to win races, not to ride to Starbucks for a latte. Treat them with respect.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1572480187/frontend_assets/hondaImages/image2.jpg',
        altText:
          'Black Honda Goldwing motorcycle on a highway in the countryside | Twisted Road Motorcycle Rental',
        title: 'Touring',
        parahraphOne:
          'It’s difficult to consider a long motorcycle tour without seriously considering comfort, and the Honda Goldwing. With extreme comfort for the rider and the passenger, plenty of storage, and all sorts of accessories (like reverse, and air-conditioning), this motorcycle is the gold standard.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
      },
    ],
  },
]

export const yamahaDescription =
  'Discover the thrill and precision of riding a Yamaha motorcycle, where advanced engineering meets exceptional performance. Yamaha motorcycles offer a diverse range of models perfect for every rider, from urban commuters to adventure seekers. With Twisted Road, you can rent the perfect Yamaha bike for your next journey and experience the freedom of the open road.'

export const yamahaDescription2 =
  ''

export const yamahaOverview =
  'Yamaha has a storied history in the motorcycle industry, dating back to its first model, the YA-1, introduced in 1955. Over the decades, Yamaha has become renowned for its innovative engineering, high performance, and reliable motorcycles. The brand has achieved numerous accolades in both racing and consumer markets, making it a trusted name for riders worldwide.'

export const yamahaOverview2 = undefined

export const yamahaImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744319225/frontend_assets/yamahaimages/main_header_image.png',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744319009/frontend_assets/yamahaimages/secondary_header_image.png',
}

export const yamahaWhyToRent = {
  'Innovative Engineering:': 'Yamaha is known for its commitment to innovation, ensuring each bike is equipped with the latest technology and engineering advancements.',
  'Performance & Reliability:': 'Yamaha motorcycles are built to perform and last, offering riders a dependable and exhilarating ride every time.',
  'Versatility:': 'Whether you’re cruising through the city or exploring rugged trails, Yamaha has a motorcycle to suit your needs.',
  'Comfort & Design:': 'Yamaha motorcycles are ergonomically designed for comfort and style, providing a smooth and enjoyable riding experience.'
}

export const yamahaHowToRent = {
  'Browse Models:': 'Explore our selection of Yamaha motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Yamaha model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Yamaha motorcycle and hit the road!'
}

export const yamahaReadyToRide = {
  description: 'Experience the thrill of riding a Yamaha motorcycle with Twisted Road. Whether you’re planning a weekend getaway or an extended tour, our selection of Yamaha bikes ensures you’ll find the perfect ride. Book your Yamaha motorcycle rental today and start your adventure!',
}

export const yamahaBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744319011/frontend_assets/yamahaimages/MT-07.jpg',
        altText:
          'Yamaha MT-07 | Twisted Road Motorcycle Rental',
        title: 'Yamaha MT-07',
        parahraphOne:
          'The Yamaha MT-07 is celebrated for its versatility and agile performance. With its 689cc liquid-cooled, inline twin-cylinder engine, the MT-07 delivers responsive power and excellent fuel efficiency. It’s perfect for both urban commuting and spirited weekend rides, offering a lightweight chassis and comfortable riding position.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "689cc liquid-cooled, inline twin-cylinder engine",
          "Lightweight and agile",
          "Comfortable riding position",
          "ABS for enhanced safety"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744319009/frontend_assets/yamahaimages/YZF-R3.jpg',
        altText:
          'Yamaha YZF-R3 | Twisted Road Motorcycle Rental',
        title: 'Yamaha YZF-R3',
        parahraphOne:
          'The Yamaha YZF-R3 is a sportbike designed for riders who crave speed and agility. With its 321cc liquid-cooled, inline twin-cylinder engine, the YZF-R3 offers impressive performance and handling. It’s ideal for both novice and experienced riders looking for a thrilling ride.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "321cc liquid-cooled, inline twin-cylinder engine",
          "Lightweight and nimble",
          "Sporty riding position",
          "Advanced suspension and braking systems",
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744319009/frontend_assets/yamahaimages/V_Star_250.jpg',
        altText:
          'Yamaha V Star 250 | Twisted Road Motorycle Rental',
        title: 'Yamaha V Star 250',
        parahraphOne:
          'The Yamaha V Star 250 is perfect for riders seeking a classic cruiser experience with a low seat height—perfect for shorter and new riders. Its 249cc air-cooled V-twin engine provides smooth power delivery and excellent fuel efficiency. The V Star 250’s lightweight design and comfortable seating make it an ideal choice for new riders and veterans alike.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "249cc air-cooled V-twin engine",
          "Classic cruiser styling",
          "Low seat height for easy handling",
          "Fuel-efficient and reliable",
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744319010/frontend_assets/yamahaimages/Super_Te%CC%81ne%CC%81re%CC%81_ES.jpg',
        altText:
          'Yamaha Super Ténéré ES | Twisted Road Motorcycle Rental',
        title: 'Yamaha Super Ténéré ES',
        parahraphOne:
          'The Yamaha Super Ténéré ES is built for adventure, offering robust performance and advanced features. Its 1199cc liquid-cooled, inline twin-cylinder engine provides ample power for both on-road and off-road adventures. The Super Ténéré ES also features electronic suspension, traction control, and ABS for a safe and comfortable ride.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "1199cc liquid-cooled, inline twin-cylinder engine",
          "Electronic suspension and traction control",
          "Comfortable for long-distance riding",
          "Advanced electronics package",
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744319009/frontend_assets/yamahaimages/V_Star_1300.webp',
        altText:
          'Yamaha V Star 1300 | Twisted Road Motorcycle Rental',
        title: 'Yamaha V Star 1300',
        parahraphOne:
          'Combining classic cruiser design with modern performance, the Yamaha V Star 1300 is a standout choice. Its 1304cc liquid-cooled, V-twin engine offers smooth, reliable power for both city and highway riding. The V Star 1300 features a comfortable seat and ergonomics tailored for long rides.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "1304cc liquid-cooled, V-twin engine",
          "Classic cruiser design",
          "Comfortable seating and ergonomics",
          "Reliable and powerful performance",
        ]
      },
    ],
  },
]

export const suzukiDescription =
  'Discover the thrill of riding a Suzuki motorcycle, where cutting-edge technology meets unparalleled performance. Suzuki motorcycles offer a diverse range of models perfect for every type of rider, from the urban commuter to the adventure seeker. With Twisted Road, you can rent the perfect Suzuki bike for your next journey and experience the freedom of the open road.'

export const suzukiDescription2 = ''

export const suzukiOverview =
  'Suzuki has a rich history in the motorcycle industry, dating back to its first motorcycle, the Power Free, introduced in 1952. Over the decades, Suzuki has become known for its innovative engineering, high performance, and reliable motorcycles across various segments, from sport to cruiser to dirt. The brand has achieved numerous accolades in racing and consumer markets alike, making it a trusted name for riders worldwide.'

export const suzukiOverview2 = undefined

export const suzukiImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744392426/frontend_assets/suzukiimages/main_header_image.webp',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744393646/frontend_assets/suzukiimages/secondary_header_image.png',
}

export const suzukiWhyToRent = {
  'Innovative Engineering:': 'Suzuki is known for its commitment to innovation, ensuring each bike is equipped with the latest technology and engineering advancements.',
  'Performance & Reliability: ': 'Suzuki motorcycles are built to perform and last, offering riders a dependable and exhilarating ride every time.',
  'Versatility:': 'Whether you’re cruising through the city or exploring rugged trails, Suzuki has a motorcycle to suit your needs.',
  'Comfort & Design:': 'Ergonomically designed for comfort and style, Suzuki motorcycles provide a smooth and enjoyable riding experience.'
}

export const suzukiHowToRent = {
  'Browse Models:': 'Explore our selection of Suzuki motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Suzuki model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Suzuki motorcycle and hit the road!'
}

export const suzukiReadyToRide = {
  description: 'Experience the thrill of riding a Suzuki motorcycle with Twisted Road. Whether you’re planning a weekend getaway or an extended tour, our selection of Suzuki bikes ensures you’ll find the perfect ride. Book your Suzuki motorcycle rental today and start your adventure!',
}

export const suzukiBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744394144/frontend_assets/suzukiimages/SV650.webp',
        altText:
          'Suzuki SV650 | Twisted Road Motorycle Rental',
        title: 'Suzuki SV650',
        parahraphOne:
          'The Suzuki SV650 is celebrated for its versatility, blending agile performance with a user-friendly design. Ideal for both new riders and seasoned veterans, along with racers in Lightweight Twin classes, the SV650 features a powerful 645cc V-twin engine, ensuring a responsive and exhilarating ride. It also offers a lightweight chassis, making it perfect for navigating urban environments and spirited weekend rides.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "645cc V-twin engine",
          "Traction control system",
          "Comfortable seating for long rides",
          "ABS and adjustable suspension"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744398736/frontend_assets/suzukiimages/V-Strom_650.webp',
        altText:
          'Suzuki V-Strom 650 | Twisted Road Motorycle Rental',
        title: 'Suzuki V-Strom 650',
        parahraphOne:
          'Perfect for adventure seekers, the Suzuki V-Strom 650 offers exceptional performance on city streets and off-road trails. Its 645cc V-twin engine, combined with advanced electronics and robust design, makes it ideal for long-distance touring. The V-Strom 650 also features a comfortable seat and adjustable windscreen for added rider comfort.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "645cc V-twin engine",
          "Traction control system",
          "Comfortable seating for long rides",
          "ABS and adjustable suspension",
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744399485/frontend_assets/suzukiimages/V-Strom_850.webp',
        altText:
          'Suzuki V-Strom 850 | Twisted Road Motorcycle Rental',
        title: 'Suzuki V-Strom 850',
        parahraphOne:
          'The Suzuki V-Strom 850 is designed for the ultimate adventure, offering more power and advanced features and power compared to its 650 sibling. With an 850cc engine, this bike is perfect for tackling both highway journeys and off-road adventures. The V-Strom 850 includes advanced rider aids like multiple riding modes and a comprehensive electronics package.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "850cc V-twin engine",
          "Multiple riding modes",
          "Advanced electronics package",
          "Long-distance comfort and rugged design"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744399764/frontend_assets/suzukiimages/GSX-R600.webp',
        altText:
          'Suzuki GSX-R600 | Twisted Road Motorcycle Rental',
        title: 'Suzuki GSX-R600',
        parahraphOne:
          'The Suzuki GSX-R600 is a sportbike icon, delivering high performance and agility. With its 599cc engine and race-ready features, this bike is perfect for those who crave speed and precision on the road. The GSX-R600 also features advanced suspension and braking systems to ensure optimal performance and safety.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "599cc inline-four engine",
          "Lightweight chassis",
          "Advanced suspension and braking systems",
          "Slipper clutch and ABS"
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744399961/frontend_assets/suzukiimages/Boulevard_M109R.webp',
        altText:
          'Suzuki Boulevard M109R | Twisted Road Motorcycle Rental',
        title: 'Suzuki Boulevard M109R',
        parahraphOne:
          'Combining muscle bike performance with cruiser comfort, the Suzuki Boulevard M109R is a head-turner. Its powerful 1783cc V-twin engine and bold design make it an excellent choice for riders looking to make a statement. The M109R also offers a smooth ride and comfortable seating for long-distance cruising.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "1783cc V-twin engine",
          "Aggressive styling",
          "Comfortable cruiser seating",
          "Advanced suspension for a smooth ride"
        ]
      },
    ],
  },
]

export const ktmDescription =
  'Embrace the spirit of adventure and high performance with KTM motorcycles. Renowned for its rugged design, powerful engines, and off-road capabilities, KTM bikes offer an unparalleled riding experience. Whether you’re tackling challenging trails or cruising city streets, Twisted Road has the perfect KTM rental to fuel your next adventure.'

export const ktmDescription2 = ''

export const ktmOverview =
  'KTM, founded in 1934 in Austria, has grown from a small metalworking shop into one of the most respected names in the motorcycle industry. Known for their innovative designs and competitive edge in motorsports, KTM motorcycles deliver unmatched performance, whether on dirt tracks or asphalt roads. KTM’s dedication to quality and precision engineering has cemented its reputation among riders worldwide.'

export const ktmOverview2 = undefined

export const ktmImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744692617/frontend_assets/ktmimages/main_header_image.webp',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744692617/frontend_assets/ktmimages/secondary_header_image.webp',
}

export const ktmWhyToRent = {
  'Off-Road Mastery:': 'KTM is synonymous with off-road excellence, offering bikes that excel on dirt trails and rugged terrain.',
  'Cutting-Edge Technology:': 'KTM integrates advanced technology into every model, ensuring top-tier performance and safety.',
  'Powerful Engines:': 'Known for their robust and high-performance engines, KTM motorcycles provide an exhilarating riding experience.',
  'Versatile Range:': 'From enduro bikes to adventure tourers, KTM has a model to suit every rider’s needs and preferences.'
}

export const ktmHowToRent = {
  'Browse Models:': 'Explore our selection of KTM motorcycles available for rent.',
  'Choose Your Ride:': 'Select the KTM model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your KTM motorcycle and hit the road or trail!'
}

export const ktmReadyToRide = {
  description: 'Experience the thrill and performance of a KTM motorcycle with Twisted Road. Whether you’re planning an off-road adventure or a city tour, our selection of KTM bikes ensures you’ll find the perfect ride. Book your KTM motorcycle rental today and start your journey!',
}

export const ktmBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744692615/frontend_assets/ktmimages/390_Duke.webp',
        altText:
          'KTM 390 Duke | Twisted Road Motorcycle Rental',
        title: 'KTM 390 Duke',
        parahraphOne:
          'Description: The KTM 390 Duke is a lightweight naked bike that offers impressive performance and agility. With a 373cc single-cylinder engine, the 390 Duke is perfect for urban commuting and spirited rides. Its advanced features include a TFT display, ride-by-wire throttle, and ABS, ensuring both safety and fun.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "373cc single-cylinder engine",
          "Lightweight and agile chassis",
          "TFT display and ride-by-wire throttle",
          "ABS for enhanced safety"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744692615/frontend_assets/ktmimages/690_Enduro_R.webp',
        altText:
          'KTM 690 Enduro R | Twisted Road Motorcycle Rental',
        title: 'KTM 690 Enduro R',
        parahraphOne:
          'The KTM 690 Enduro R combines off-road capability with street performance. Its 69ccc single-cylinder engine delivers powerful torque and excellent handling on any terrain. The bike features advanced electronics, including ride modes and traction control, making it a versatile choice for adventure seekers.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "693cc single-cylinder engine",
          "Advanced ride modes and traction control",
          "High-ground clearance and suspension travel",
          "Ideal for both off-road and street riding"
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744692616/frontend_assets/ktmimages/790_Adventure.webp',
        altText:
          'KTM 790 Adventure | Twisted Road Motorcycle Rental',
        title: 'KTM 790 Adventure',
        parahraphOne:
          'The KTM 790 Adventure is designed for long-distance touring and off-road exploration. Its 799cc parallel-twin engine provides smooth power delivery, while the lightweight chassis and long-travel suspension ensure comfort and control. The 790 Adventure is equipped with advanced electronics like cornering ABS and traction control.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "799cc parallel-twin engine",
          "Long-travel suspension for comfort and control",
          "Cornering ABS and traction control",
          "Suitable for long-distance touring and off-road exploration"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744692616/frontend_assets/ktmimages/1290_Super_Adventure_R.webp',
        altText:
          'KTM 1290 Super Adventure R | Twisted Road Motorcycle Rental',
        title: 'KTM 1290 Super Adventure R',
        parahraphOne:
          'The KTM 1290 Super Adventure R is the ultimate adventure bike and one of the BMW 1250 GS’s largest rival, boasting a powerful 1301cc V-twin engine and advanced electronics. Designed for serious off-road riding, it features long-travel suspension, off-road ABS, and multiple ride modes. The 1290 Super Adventure R is perfect for riders seeking extreme adventures.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "1301cc V-twin engine",
          "Off-road ABS and multiple ride modes",
          "Long-travel suspension for rugged terrains",
          "Ideal for extreme off-road adventures"
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744692616/frontend_assets/ktmimages/500_EXC-F.webp',
        altText:
          'KTM 500 EXC-F | Twisted Road Motorcycle Rental',
        title: 'KTM 500 EXC-F',
        parahraphOne:
          'The KTM 500 EXC-F is a high-performance enduro bike, powered by a 510cc single-cylinder engine. It offers exceptional off-road capabilities with its lightweight frame and advanced suspension. The 500 EXC-F is perfect for riders looking to conquer challenging trails and off-road courses.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "510cc single-cylinder engine",
          "Lightweight and agile frame",
          "Advanced suspension for off-road performance",
          "Ideal for enduro and off-road riding"
        ]
      },
    ],
  },
]

export const kawasakiDescription =
  'Experience the thrill and precision of Kawasaki motorcycles, where cutting-edge technology meets exceptional performance. Kawasaki offers a diverse range of models perfect for every rider, from urban commuters to adventure seekers. With Twisted Road, you can rent the perfect Kawasaki bike for your next journey and embrace the freedom of the open road.'

export const kawasakiDescription2 = ''

export const kawasakiOverview =
  'Kawasaki’s history in the motorcycle industry dates back to 1962, when the company produced its first bike, the B8. Since then, Kawasaki has become renowned for its high-performance motorcycles, innovative engineering, and dominance in both racing and consumer markets. The brand’s commitment to quality and performance makes it a favorite among riders worldwide.'

export const kawasakiOverview2 = undefined

export const kawasakiImages = {
  heroImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744754083/frontend_assets/kawasakiimages/main_header_image.webp',
  logo: '',
  bikeImage:
    'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1744754345/frontend_assets/kawasakiimages/secondary_header_image.webp',
}

export const kawasakiWhyToRent = {
  'Innovative Engineering:': 'Kawasaki is known for pushing the boundaries of motorcycle technology, ensuring each model is equipped with the latest advancements.',
  'Performance & Reliability:': 'Kawasaki motorcycles deliver high performance and reliability, offering riders an exhilarating and dependable ride.',
  'Versatility:': 'From powerful sport bikes to rugged adventure bikes, Kawasaki has a model for every type of rider and terrain.',
  'Comfort & Design:': 'Kawasaki bikes are designed with rider comfort in mind, providing a smooth and enjoyable experience for all.'
}

export const kawasakiHowToRent = {
  'Browse Models:': 'Explore our selection of Kawasaki motorcycles available for rent.',
  'Choose Your Ride:': 'Select the Kawasaki model that suits your adventure.',
  'Book & Confirm:': 'Book your rental and receive confirmation details.',
  'Pick Up & Ride:': 'Pick up your Kawasaki motorcycle and hit the road!'
}

export const kawasakiReadyToRide = {
  description: 'Experience the thrill of riding a Kawasaki motorcycle with Twisted Road. Whether you’re planning a weekend getaway or an extended tour, our selection of Kawasaki bikes ensures you’ll find the perfect ride. Book your Kawasaki motorcycle rental today and start your adventure! ',
}

export const kawasakiBikeData = [
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744754694/frontend_assets/kawasakiimages/Ninja_400.webp',
        altText:
          'Kawasaki Ninja 400 | Twisted Road Motorcycle Rental',
        title: 'Kawasaki Ninja 400',
        parahraphOne:
          'The Kawasaki Ninja 400 is the perfect blend of power and agility. With a 399cc twin-cylinder engine, it offers impressive performance and handling, making it ideal for both novice and experienced riders. Features like a slipper clutch and ABS enhance safety and control.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "399cc twin-cylinder engine",
          "Lightweight and nimble design",
          "Slipper clutch and ABS for enhanced safety",
          "Comfortable riding position"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744754937/frontend_assets/kawasakiimages/Z650.webp',
        altText:
          'Kawasaki Z650 | Twisted Road Motorcycle Rental',
        title: 'Kawasaki Z650',
        parahraphOne:
          'The Kawasaki Z650 is a versatile naked bike known for its responsive performance and stylish design. Its 649cc parallel-twin engine delivers smooth power, while the lightweight chassis ensures easy maneuverability. The Z650 is perfect for urban commutes and spirited rides.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "649cc parallel-twin engine",
          "Lightweight and agile chassis",
          "Comfortable upright riding position",
          "Advanced electronics, including ABS"
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744755137/frontend_assets/kawasakiimages/Vulcan_S.webp',
        altText:
          'Kawasaki Vulcan S | Twisted Road Motorcycle Rental',
        title: 'Kawasaki Vulcan S',
        parahraphOne:
          'The Kawasaki Vulcan S is a cruiser that combines comfort with performance. Its 649cc parallel-twin engine provides a smooth and responsive ride, while the Ergo-Fit system allows riders to adjust the bike to their preferred riding position. The Vulcan S is perfect for long rides and city cruising.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "649cc parallel-twin engine",
          "Ergo-Fit adjustable riding positions",
          "Comfortable cruiser design",
          "Advanced safety features"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744755283/frontend_assets/kawasakiimages/Versys_650.webp',
        altText:
          'Kawasaki Versys 650 | Twisted Road Motorcycle Rental',
        title: 'Kawasaki Versys 650',
        parahraphOne:
          'The Kawasaki Versys 650 is an adventure bike designed for versatility and comfort. Its 649cc parallel-twin engine offers reliable performance on both paved and unpaved roads. The Versys 650 features a comfortable seat and advanced suspension, making it ideal for long-distance touring.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "649cc parallel-twin engine",
          "Advanced suspension for varied terrains",
          "Comfortable seating for long rides",
          "Multiple riding modes"
        ]
      },
    ],
  },
  {
    group: [
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744755416/frontend_assets/kawasakiimages/Ninja_ZX-6R.webp',
        altText:
          'Kawasaki Ninja ZX-6R | Twisted Road Motorcycle Rental',
        title: 'Kawasaki Ninja ZX-6R',
        parahraphOne:
          'The Kawasaki Ninja ZX-6R is a sportbike that delivers exceptional performance and handling. Its 636cc inline-four engine offers exhilarating power, while the advanced electronics package, including traction control and ABS, ensures safety and control. The ZX-6R is perfect for riders seeking a high-performance experience.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "636cc inline-four engine",
          "Advanced electronics, including traction control and ABS",
          "Aerodynamic design for high-speed stability",
          "Adjustable suspension for precise handling"
        ]
      },
      {
        image:
          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto,w_650,h_450/v1744755555/frontend_assets/kawasakiimages/KLR_650.webp',
        altText:
          'Kawasaki KLR 650 | Twisted Road Motorycle Rental',
        title: 'Kawasaki KLR 650',
        parahraphOne:
          'The Kawasaki KLR 650 is the grandaddy of all dual sports. The bike is built for adventure, offering robust performance and advanced features for rugged terrain. Its 652cc liquid-cooled engine delivers solid power for both on-road and off-road journeys. The KLR 650 ABS for enhanced safety.',
        parahraphTwo: undefined,
        clickHereLinkText: undefined,
        features: [
          "KLR 650 liquid-cooled engine",
          "Long-travel suspension",
          "Advanced comfort for longer rides",
          "Comfortable for long-distance touring"
        ]
      },
    ],
  },
]
